import { ChevronDownIcon, ChevronUpIcon } from "../Icons"
import { Button } from "../Button"
import { ClearIcon } from "../styles/shared"
import { Variant } from "./types"

const Clear = ({ onClear }: { onClear: () => void }) => (
  <Button variant="reset" onClick={onClear}>
    <ClearIcon />
  </Button>
)

const ToggleOpen = ({ toggleOpen, isOpen }: { toggleOpen: () => void; isOpen: boolean }) => (
  <Button variant="reset" onClick={toggleOpen}>
    {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
  </Button>
)

type Props = {
  variant?: Variant
  value?: string | null
  disabled?: boolean
  isOpen: boolean
  onClear: () => void
  toggleOpen: () => void
}

export const InputButton = ({ disabled, value, variant, isOpen, onClear, toggleOpen }: Props) => {
  if (disabled) return null
  if (value && value !== ``) return <Clear onClear={onClear} />
  if (variant === `search`) return null
  return <ToggleOpen {...{ isOpen, toggleOpen }} />
}

InputButton.defaultProps = {
  variant: undefined,
  disabled: false,
  value: undefined,
}
